<div class="carousel-container">
  <swiper-container 
  #logoSwiper 
  class="carousel-swiper" 
  centeredSlides="true"
  autoplay="false"
  (swiperbreakpoint)="onBreakpointChange($event)">
    @for (logo of carouselLogos(); track logo.uuid) {
        @let url = logoCarouselFolder + logo.uuid + '/' + logoCarouselFileName;
        <swiper-slide>
          <img [src]="url" class="carousel-logo" alt="{{logo.alt ? logo.alt : 'Logo'}}"/>
        </swiper-slide>
    }
  </swiper-container>
</div>

@if (openEditCarousel) {
<div class="lightbox admin-theme">
  <div class="lightbox-content admin-mode">
    <app-edit-logo-carousel 
      [elemId]="configId"
      (onClose)="openEditCarousel = false">
    </app-edit-logo-carousel>
  </div>
</div>
}